import { formatUnitWithSymbol, formatValueWithUnit } from "utils/functions";
import { formatReading } from "utils/gatewayFunctions";

export const getSensorUnit = (row: any): string => {
    return row?.unit ?? row?.UNIT ?? "";
};

export const formatSensorReadingCellValue = (
    row: any,
    fallbackValue?: any
): string => {
    const rawValue = row?.readings?.value ?? fallbackValue;
    if (rawValue === undefined || rawValue === null || rawValue === "-") {
        return "-";
    }

    const numericValue =
        typeof rawValue === "number" ? rawValue : Number(rawValue);

    const accuracyRaw = row?.accuracy ?? 2;
    const accuracy =
        typeof accuracyRaw === "number" ? accuracyRaw : Number(accuracyRaw);

    return formatValueWithUnit(
        formatReading(numericValue, accuracy),
        formatUnitWithSymbol(getSensorUnit(row))
    );
};

export const formatSensorMinMaxCellValue = (row: any): string => {
    const lowestRaw = row?.readings?.lowest;
    const highestRaw = row?.readings?.highest;

    if (
        lowestRaw === undefined ||
        lowestRaw === null ||
        lowestRaw === "-" ||
        highestRaw === undefined ||
        highestRaw === null ||
        highestRaw === "-"
    ) {
        return "-";
    }

    const lowest =
        typeof lowestRaw === "number" ? lowestRaw : Number(lowestRaw);
    const highest =
        typeof highestRaw === "number" ? highestRaw : Number(highestRaw);

    const accuracyRaw = row?.accuracy ?? 2;
    const accuracy =
        typeof accuracyRaw === "number" ? accuracyRaw : Number(accuracyRaw);

    const value = `${formatReading(lowest, accuracy)} / ${formatReading(
        highest,
        accuracy
    )}`;

    return formatValueWithUnit(value, formatUnitWithSymbol(getSensorUnit(row)));
};
